import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import type {
  FlexibilityPrices,
  SupplierAllocation,
  SupplierAllocationsParams,
  SupplierAllocationsUpdate,
  SupplierBlend,
} from '@ps/survey-utils';

import { SupplierApi } from '../../api/supplier/supplier.api';

@Injectable({ providedIn: 'root' })
export class SupplierService {
  private readonly _api = inject(SupplierApi);

  public flexibilityPriceParams(
    surveyId: number,
  ): Observable<FlexibilityPrices> {
    return this._api.flexibilityPriceParams(surveyId);
  }

  public blends(locale: string): Observable<SupplierBlend[]> {
    return this._api.blends(locale);
  }

  public allocations(
    surveyId: number,
    params: SupplierAllocationsParams,
  ): Observable<SupplierAllocation[]> {
    return this._api.allocations(surveyId, params);
  }

  public updateAllocations(
    surveyId: number,
    update: SupplierAllocationsUpdate,
  ): Observable<SupplierAllocation[]> {
    return this._api.updateAllocations(surveyId, update);
  }
}
